import { Grid, Paper, useTheme } from "@mui/material";
import { RegistrationDto } from "../../store/models/registration/RegistrationDto";
import { FormDate } from "../atoms/FormDate";
import { FormInput } from "../atoms/FormInput";
import { FormSelect } from "../atoms/FormSelect";
import ImsPaperHead from "../atoms/ImsPaperHead";
import { nameof } from "../atoms/Utils";
import { getLabelText, RegistrationFormThunkProps } from "./RegistrationForm";
import { useTranslation } from "react-i18next";
import { useGenderOptions } from "../../store/models/customer/Gender";

const PersonalData = (props: RegistrationFormThunkProps) => {
  const theme = useTheme();
  const { branchStores, registrationFieldConfig } = props;
  const { t } = useTranslation();
  const genderOptions = useGenderOptions();
  return (
    <Paper
      style={{
        padding: theme.spacing(3),
        marginTop: theme.spacing(6),
        marginBottom: theme.spacing(6),
      }}
    >
      <ImsPaperHead text={t("registration.headlinePersonalInformation")} />
      <Grid container spacing={4}>
        <Grid item md={4}>
          <FormInput
            type="text"
            name={nameof<RegistrationDto>("title")}
            label={getLabelText(t("registration.title"), nameof<RegistrationDto>("title"), registrationFieldConfig)}
            fullWidth={true}
            variant="outlined"
            fieldConfig={registrationFieldConfig}
          />
        </Grid>

        <Grid
          container
          spacing={4}
          style={{
            margin: theme.spacing(0),
          }}
        >
          <Grid item md={4}>
            <FormInput
              type="text"
              fullWidth={true}
              name={nameof<RegistrationDto>("firstName")}
              label={getLabelText(
                t("registration.firstName"),
                nameof<RegistrationDto>("firstName"),
                registrationFieldConfig
              )}
              variant="outlined"
              fieldConfig={registrationFieldConfig}
            />
          </Grid>
          <Grid item md={4}>
            <FormInput
              type="text"
              fullWidth={true}
              name={nameof<RegistrationDto>("lastName")}
              label={getLabelText(
                t("registration.surname"),
                nameof<RegistrationDto>("lastName"),
                registrationFieldConfig
              )}
              variant="outlined"
              fieldConfig={registrationFieldConfig}
            />
          </Grid>
        </Grid>

        <Grid item md={4}>
          <FormSelect
            name={nameof<RegistrationDto>("gender")}
            label={getLabelText(t("registration.gender"), nameof<RegistrationDto>("gender"), registrationFieldConfig)}
            options={genderOptions}
            fullWidth={true}
            fieldConfig={registrationFieldConfig}
          />
        </Grid>
        <Grid item md={4}>
          <FormDate
            name={nameof<RegistrationDto>("dateOfBirth")}
            label={getLabelText(
              t("registration.birthday"),
              nameof<RegistrationDto>("dateOfBirth"),
              registrationFieldConfig
            )}
            fullWidth={true}
            fieldConfig={registrationFieldConfig}
          />
        </Grid>

        <Grid
          container
          spacing={4}
          style={{
            margin: theme.spacing(0),
          }}
        >
          <Grid item md={4}>
            <FormSelect
              name={nameof<RegistrationDto>("externalMasterUnitNumber")}
              label={getLabelText(
                t("registration.mainBranch"),
                nameof<RegistrationDto>("externalMasterUnitNumber"),
                registrationFieldConfig
              )}
              options={[{ label: t("registration.inputPlaceHolder"), value: "" }].concat(
                branchStores.map((branchStore) => ({
                  label: branchStore.unitName,
                  value: branchStore.unitNumber,
                }))
              )}
              fullWidth={true}
              fieldConfig={registrationFieldConfig}
            />
          </Grid>
          <Grid item md={4}>
            <FormInput
              type="text"
              fullWidth={true}
              name={nameof<RegistrationDto>("externalCustomerId")}
              label={getLabelText(
                t("registration.memberNumber"),
                nameof<RegistrationDto>("externalCustomerId"),
                registrationFieldConfig
              )}
              variant="outlined"
              fieldConfig={registrationFieldConfig}
            />
          </Grid>
        </Grid>

        <Grid item md={4}>
          <FormInput
            type="text"
            name={nameof<RegistrationDto>("companyName")}
            label={getLabelText(
              t("registration.companyName"),
              nameof<RegistrationDto>("companyName"),
              registrationFieldConfig
            )}
            fullWidth={true}
            variant="outlined"
            fieldConfig={registrationFieldConfig}
          />
        </Grid>
        <Grid item md={4}>
          <FormInput
            type="text"
            name={nameof<RegistrationDto>("vatId")}
            label={getLabelText(t("registration.vatId"), nameof<RegistrationDto>("vatId"), registrationFieldConfig)}
            fullWidth={true}
            variant="outlined"
            fieldConfig={registrationFieldConfig}
          />
        </Grid>
      </Grid>
    </Paper>
  );
};

export default PersonalData;
